import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationEaseIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAnimationEaseIn"><Path fillRule="evenodd" clipRule="evenodd" d="M21.1424 3.1762L20.9834 3.90914C19.9473 8.68246 18.1047 12.4435 15.2743 15.2739C12.4439 18.1043 8.68283 19.9469 3.9095 20.983L3.17657 21.1421L2.8584 19.6762L3.59133 19.5171C8.16234 18.525 11.6372 16.7897 14.2136 14.2133C16.7901 11.6368 18.5253 8.16197 19.5175 3.59097L19.6766 2.85803L21.1424 3.1762Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationEaseIn;
